import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accounting-myob-tax-codes',
  templateUrl: './accounting-myob-tax-codes.component.html',
  styleUrls: ['./accounting-myob-tax-codes.component.css']
})
export class AccountingMyobTaxCodesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
